import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    width: 100vw;
    padding-left:5%;
    padding-right:5%;
}
`;

export const Shape = styled.div`
    clip-path: polygon(100% 0, 0 0, 100% 100%);
    background: #1F85FF;
    position: absolute;
    top: 0px;
    right: 0px;
    width: 50vw;
    height: 100vh;
    z-index: -100;
}
`;
